// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageDetailsStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanPackageDetailsStepQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, name: string, code?: string | null | undefined, lotTypes?: Array<Types.LotType> | null | undefined, insideMapsProjectId?: string | null | undefined, insideMapsConfig?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, markets: Array<{ __typename?: 'Market', id: string, name: string }>, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, programData: { __typename?: 'ProgramData', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string } }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
          | { __typename?: 'ReadyPlan', id: string }
          | { __typename?: 'ReadyPlanLocation', id: string }
          | { __typename?: 'ReadyPlanOption', id: string }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'DesignPackage', id: string }
          | { __typename?: 'ProductOffering', id: string }
         | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'ReadyPlanLocation', id: string }
        | { __typename?: 'ReadyPlanOption', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }> } };

export type SavePlanPackageDetailsMutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type SavePlanPackageDetailsMutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, name: string, code?: string | null | undefined, lotTypes?: Array<Types.LotType> | null | undefined, insideMapsProjectId?: string | null | undefined, insideMapsConfig?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, markets: Array<{ __typename?: 'Market', id: string, name: string }>, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, programData: { __typename?: 'ProgramData', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string } }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
            | { __typename?: 'ReadyPlan', id: string }
            | { __typename?: 'ReadyPlanLocation', id: string }
            | { __typename?: 'ReadyPlanOption', id: string }
            | { __typename?: 'PlanPackage', id: string }
            | { __typename?: 'DesignPackage', id: string }
            | { __typename?: 'ProductOffering', id: string }
           | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
          | { __typename?: 'ReadyPlan', id: string }
          | { __typename?: 'ReadyPlanLocation', id: string }
          | { __typename?: 'ReadyPlanOption', id: string }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'DesignPackage', id: string }
          | { __typename?: 'ProductOffering', id: string }
         | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }> } } };

export type PlanPackageDetailsStep_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, name: string, code?: string | null | undefined, lotTypes?: Array<Types.LotType> | null | undefined, insideMapsProjectId?: string | null | undefined, insideMapsConfig?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, markets: Array<{ __typename?: 'Market', id: string, name: string }>, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, programData: { __typename?: 'ProgramData', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string } }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'ReadyPlanLocation', id: string }
        | { __typename?: 'ReadyPlanOption', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
      | { __typename?: 'ReadyPlan', id: string }
      | { __typename?: 'ReadyPlanLocation', id: string }
      | { __typename?: 'ReadyPlanOption', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'DesignPackage', id: string }
      | { __typename?: 'ProductOffering', id: string }
     | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }> };

export type ReadyPlanOptionElevationFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string } }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
      | { __typename?: 'ReadyPlan', id: string }
      | { __typename?: 'ReadyPlanLocation', id: string }
      | { __typename?: 'ReadyPlanOption', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'DesignPackage', id: string }
      | { __typename?: 'ProductOffering', id: string }
     | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } };

export type ReadyPlanAssetFragment = { __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, active: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined, downloadUrl: string, fileName?: string | null | undefined }, parent?:
    | { __typename?: 'ReadyPlan', id: string }
    | { __typename?: 'ReadyPlanLocation', id: string }
    | { __typename?: 'ReadyPlanOption', id: string }
    | { __typename?: 'PlanPackage', id: string }
    | { __typename?: 'DesignPackage', id: string }
    | { __typename?: 'ProductOffering', id: string }
   | null | undefined, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string } };

export type RpaParent_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string };

export type RpaParent_ReadyPlanLocation_Fragment = { __typename?: 'ReadyPlanLocation', id: string };

export type RpaParent_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', id: string };

export type RpaParent_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string };

export type RpaParent_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string };

export type RpaParent_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string };

export type RpaParentFragment =
  | RpaParent_ReadyPlan_Fragment
  | RpaParent_ReadyPlanLocation_Fragment
  | RpaParent_ReadyPlanOption_Fragment
  | RpaParent_PlanPackage_Fragment
  | RpaParent_DesignPackage_Fragment
  | RpaParent_ProductOffering_Fragment
;

export const RpaParentFragmentDoc = gql`
    fragment RPAParent on ReadyPlanAssetParent {
  ... on Named {
    id
  }
}
    `;
export const ReadyPlanAssetFragmentDoc = gql`
    fragment ReadyPlanAsset on ReadyPlanAsset {
  id
  asset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
    downloadUrl
    fileName
  }
  parent {
    ...RPAParent
  }
  type {
    code
    name
  }
  isCoverPhoto
  active
}
    ${RpaParentFragmentDoc}`;
export const ReadyPlanOptionElevationFragmentDoc = gql`
    fragment ReadyPlanOptionElevation on ReadyPlanOption {
  id
  name
  displayName
  active
  type {
    id
    isElevation
  }
  globalOption {
    id
    group {
      id
    }
  }
  assets {
    ...ReadyPlanAsset
  }
  optionGroup {
    id
    options {
      id
    }
  }
  order
}
    ${ReadyPlanAssetFragmentDoc}`;
export const PlanPackageDetailsStep_PlanPackageFragmentDoc = gql`
    fragment PlanPackageDetailsStep_PlanPackage on PlanPackage {
  id
  description
  name
  code
  lotTypes
  insideMapsProjectId
  insideMapsConfig
  version {
    id
  }
  canEdit {
    ...PotentialOperationDetails
  }
  development {
    id
    name
  }
  markets {
    ...Named
  }
  type {
    code
    name
  }
  status {
    code
    name
  }
  programData {
    id
  }
  options {
    ...ReadyPlanOptionElevation
  }
  optionGroups {
    id
    group {
      id
      type {
        id
        isElevation
      }
    }
  }
  assets {
    ...ReadyPlanAsset
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}
${ReadyPlanOptionElevationFragmentDoc}
${ReadyPlanAssetFragmentDoc}`;
export const PlanPackageDetailsStepDocument = gql`
    query PlanPackageDetailsStep($id: ID!, $versionId: ID) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageDetailsStep_PlanPackage
  }
}
    ${PlanPackageDetailsStep_PlanPackageFragmentDoc}`;

/**
 * __usePlanPackageDetailsStepQuery__
 *
 * To run a query within a React component, call `usePlanPackageDetailsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageDetailsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageDetailsStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageDetailsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables> & ({ variables: PlanPackageDetailsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>(PlanPackageDetailsStepDocument, options);
      }
export function usePlanPackageDetailsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>(PlanPackageDetailsStepDocument, options);
        }
// @ts-ignore
export function usePlanPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>;
export function usePlanPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageDetailsStepQuery | undefined, PlanPackageDetailsStepQueryVariables>;
export function usePlanPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>(PlanPackageDetailsStepDocument, options);
        }
export type PlanPackageDetailsStepQueryHookResult = ReturnType<typeof usePlanPackageDetailsStepQuery>;
export type PlanPackageDetailsStepLazyQueryHookResult = ReturnType<typeof usePlanPackageDetailsStepLazyQuery>;
export type PlanPackageDetailsStepSuspenseQueryHookResult = ReturnType<typeof usePlanPackageDetailsStepSuspenseQuery>;
export type PlanPackageDetailsStepQueryResult = Apollo.QueryResult<PlanPackageDetailsStepQuery, PlanPackageDetailsStepQueryVariables>;
export const SavePlanPackageDetailsDocument = gql`
    mutation SavePlanPackageDetails($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      ...PlanPackageDetailsStep_PlanPackage
    }
  }
}
    ${PlanPackageDetailsStep_PlanPackageFragmentDoc}`;
export type SavePlanPackageDetailsMutationFn = Apollo.MutationFunction<SavePlanPackageDetailsMutation, SavePlanPackageDetailsMutationVariables>;

/**
 * __useSavePlanPackageDetailsMutation__
 *
 * To run a mutation, you first call `useSavePlanPackageDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageDetailsMutation, { data, loading, error }] = useSavePlanPackageDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanPackageDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageDetailsMutation, SavePlanPackageDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageDetailsMutation, SavePlanPackageDetailsMutationVariables>(SavePlanPackageDetailsDocument, options);
      }
export type SavePlanPackageDetailsMutationHookResult = ReturnType<typeof useSavePlanPackageDetailsMutation>;
export type SavePlanPackageDetailsMutationResult = Apollo.MutationResult<SavePlanPackageDetailsMutation>;
export type SavePlanPackageDetailsMutationOptions = Apollo.BaseMutationOptions<SavePlanPackageDetailsMutation, SavePlanPackageDetailsMutationVariables>;